export const logoUrl = {
  type: "string",
  minLength: 1,
  maxLength: 2_048
};
